import { COMMON_DATE_FORMAT } from 'constants/date';
import { FieldType } from 'constants/formGenerator';

import { TableCellId } from '../DocumentExpirationDates.constants';

export const documentExpirationDatesLoanChangesConfig = {
  [TableCellId.START_DATE]: { inputProps: { format: COMMON_DATE_FORMAT } },
  [TableCellId.EXPIRATION_DATE]: { inputProps: { format: COMMON_DATE_FORMAT } },
};

export const formConfig = {
  [TableCellId.TITLE]: { fieldType: FieldType.TEXT },
  [TableCellId.START_DATE]: { fieldType: FieldType.DATE },
  [TableCellId.EXPIRES_IN_DAYS]: { fieldType: FieldType.INTEGER },
  [TableCellId.EXPIRATION_DATE]: { fieldType: FieldType.DATE },
};

export const formFields = Object.keys(formConfig);
